import React, { useEffect, useState } from 'react';
import InventoryTable from './InventoryTable';
import ImagesList from './ImagesList';
// API
import TimeSlotsService from 'services/TimeSlotsService';

const ProductDetails = ({
  cartItem,
  handleCartDetails,
  orderMapId,
  preparationStatus,
  hasSubmittedBefore,
  hasDeviation,
  setHasSubmittedBefore,
  setHasDeviation,
  floristMapId,
  productId,
}) => {
  const [inventoryDetails, setInventoryDetails] = useState([]);

  const fetchCartDetails = async () => {
    const params = {
      productionJobId: cartItem?.id,
    };
    try {
      const res = await TimeSlotsService.getProdJobInventoryDetails(params, cartItem?.productId);
      setInventoryDetails(res?.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchCartDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="productDetails-left-col">
        <div className="productDetails-left-header"></div>
        <ImagesList listOfImages={inventoryDetails?.productImages} />
        <div className="productDetails-left-details">
          <p style={{ padding: 5 }}>Qty: 1</p>
        </div>
      </div>
      <div className="productDetails-right-col">
        <div className="productDetails-right-header">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Item Image</th>
                <th scope="col">Name</th>
                <th scope="col">Barcode</th>
                <th scope="col">Qty</th>
                <th scope="col">Used Qty</th>
                <th scope="col">Damaged Qty</th>
                <th scope="col">Damaged Image</th>
              </tr>
            </thead>
          </table>
        </div>
        <InventoryTable
          inventoryData={inventoryDetails?.inventoryDto}
          orderMapId={orderMapId}
          preparationStatus={preparationStatus}
          hasSubmittedBefore={hasSubmittedBefore}
          hasDeviation={hasDeviation}
          setHasSubmittedBefore={setHasSubmittedBefore}
          setHasDeviation={setHasDeviation}
          cartQty={1}
          fetchCartDetails={fetchCartDetails}
          productionId={cartItem?.id}
          floristMapId={floristMapId}
          productId={productId}
        />
      </div>
    </>
  );
};

export default ProductDetails;
